module.exports = __webpack_public_path__ + "static/media/albatross_projects_americas_logo_dark.3dd36dd2.png";